// import React, { useState, useEffect } from 'react';
// import { alertNotification } from '../../utils/notification';
// import expenseService from '../../services/expenseService';

// /**
//  * ExpenseModal Component
//  * Modal for adding multiple expenses in batch
//  *
//  * @param {boolean}  isOpen
//  * @param {Function} onClose
//  * @param {Function} onSave
//  * @param {Object}   expense  (optional - edit mode)
//  * @param {boolean}  isSaving
//  */
// const ExpenseModal = ({ isOpen, onClose, onSave, expense, isSaving }) => {

//   // ─── Constants ────────────────────────────────────────────────────────────
//   const MAX_ITEMS    = 5;
// const EXPENSE_TYPES = [
//   'FUEL',
//   'SALARY',
//   'UTILITIES',
//   'RENT',
//   'MAINTENANCE',
//   'OFFICE_SUPPLIES',
//   'TRANSPORT',
//   'MARKETING',
//   'SOFTWARE',
//   'BANK_CHARGES',
//   'TAX',
//   'TRAVEL',
//   'FOOD'
// ];

//   // ─── State ────────────────────────────────────────────────────────────────
//   const [expenseType,     setExpenseType]     = useState('SALARY');
//   const [customType,      setCustomType]      = useState('');
//   const [showCustomType,  setShowCustomType]  = useState(false);
//   const [reason,          setReason]          = useState('');
//   const [amount,          setAmount]          = useState('');
//   const [inventories,     setInventories]     = useState([]);
//   const [inventoryId,     setInventoryId]     = useState('');
//   const [expenses,        setExpenses]        = useState([]);

//   // ─── Effects ──────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (expense) {
//       setExpenses([
//         {
//           type:   expense.type   || 'SALARY',
//           reason: expense.reason || '',
//           amount: expense.amount || 0,
//         },
//       ]);
//     } else {
//       setExpenses([]);
//     }

//     setExpenseType('SALARY');
//     setCustomType('');
//     setShowCustomType(false);
//     setReason('');
//     setAmount('');
//   }, [expense, isOpen]);

//   useEffect(() => {
//     const fetchInventories = async () => {
//       try {
//         const data = await expenseService.getActiveInventories();
//         setInventories(data);
//       } catch (error) {
//         alertNotification('Failed to load inventories', 'error');
//       }
//     };

//     if (isOpen) {
//       fetchInventories();
//     }
//   }, [isOpen]);

//   // ─── Handlers ─────────────────────────────────────────────────────────────
//   const addRow = () => {
//     if (!reason.trim()) {
//       alertNotification('Reason is required', 'error');
//       return;
//     }

//     if (!amount || parseFloat(amount) <= 0) {
//       alertNotification('Valid amount is required', 'error');
//       return;
//     }

//     if (!inventoryId) {
//       alertNotification('Inventory is required', 'error');
//       return;
//     }

//     const finalType = showCustomType ? customType.trim() : expenseType;

//     if (showCustomType && !customType.trim()) {
//       alertNotification('Custom type is required', 'error');
//       return;
//     }

//     if (expenses.length >= MAX_ITEMS) {
//       alertNotification(`Maximum ${MAX_ITEMS} expenses allowed`, 'error');
//       return;
//     }

//     setExpenses(prev => [
//       ...prev,
//       {
//         type:        finalType,
//         reason:      reason.trim(),
//         amount:      parseFloat(amount),
//         inventoryId: parseInt(inventoryId),
//       },
//     ]);

//     setReason('');
//     setAmount('');
//     if (showCustomType) setCustomType('');
//   };

//   const removeRow = (index) => {
//     setExpenses(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (expenses.length === 0) {
//       alertNotification('Please add at least one expense', 'error');
//       return;
//     }

//     onSave({ expenses });
//   };

//   const handleClose = () => {
//     if (!isSaving) {
//       onClose();
//       setExpenses([]);
//       setExpenseType('SALARY');
//       setCustomType('');
//       setShowCustomType(false);
//       setReason('');
//       setAmount('');
//     }
//   };

//   // ─── Derived ──────────────────────────────────────────────────────────────
//   const totalAmount = expenses.reduce((sum, exp) => sum + exp.amount, 0);

//   // ─── Guard ────────────────────────────────────────────────────────────────
//   if (!isOpen) return null;

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="inventory-modal-overlay">
//       <div className="inventory-modal-content" style={{ maxWidth: '800px' }}>

//         {/* ── Header ── */}
//         <header className="inventory-modal-header">
//           <h3 className="inventory-modal-title">
//             {expense ? 'Edit Expense' : 'Add New Expenses'}
//           </h3>
//           <button
//             className="inventory-close-modal-btn"
//             onClick={handleClose}
//             disabled={isSaving}
//             type="button"
//           >
//             ×
//           </button>
//         </header>

//         {/* ── Body ── */}
//         <div className="inventory-modal-body">
//           <form onSubmit={handleSubmit}>

//             {/* Form Inputs */}
//             <div
//               className="inventory-form-grid"
//               style={{ gridTemplateColumns: '1fr 2fr 1fr auto', gap: '12px', alignItems: 'end' }}
//             >
//               {/* Inventory */}
//               <div>
//                 <div>
//                   <label>Inventory *</label>
//                   <select
//                     className="inventory-custom-input"
//                     value={inventoryId}
//                     onChange={(e) => setInventoryId(e.target.value)}
//                     disabled={isSaving}
//                   >
//                     <option value="">Select Inventory</option>
//                     {inventories.map(inv => (
//                       <option key={inv.id} value={inv.id}>
//                         {inv.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Type */}
//                 <label>Type *</label>
//                 <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
//                   {!showCustomType ? (
//                     <>
//                       <select
//                         className="inventory-custom-input"
//                         value={expenseType}
//                         onChange={(e) => setExpenseType(e.target.value)}
//                         disabled={isSaving}
//                         style={{ flex: 1 }}
//                       >
//                         {EXPENSE_TYPES.map(type => (
//                           <option key={type} value={type}>{type}</option>
//                         ))}
//                       </select>
//                       <button
//                         type="button"
//                         onClick={() => setShowCustomType(true)}
//                         disabled={isSaving}
//                         title="Add custom type"
//                         style={{
//                           padding: '8px', background: '#007bff', color: 'white',
//                           border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px',
//                         }}
//                       >
//                         ✏️
//                       </button>
//                     </>
//                   ) : (
//                     <>
//                       <input
//                         type="text"
//                         className="inventory-custom-input"
//                         value={customType}
//                         onChange={(e) => setCustomType(e.target.value)}
//                         placeholder="Enter custom type"
//                         disabled={isSaving}
//                         style={{ flex: 1 }}
//                       />
//                       <button
//                         type="button"
//                         onClick={() => { setShowCustomType(false); setCustomType(''); }}
//                         disabled={isSaving}
//                         title="Back to dropdown"
//                         style={{
//                           padding: '8px', background: '#6c757d', color: 'white',
//                           border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px',
//                         }}
//                       >
//                         ↩️
//                       </button>
//                     </>
//                   )}
//                 </div>
//               </div>

//               {/* Reason */}
//               <div>
//                 <label>Reason *</label>
//                 <input
//                   type="text"
//                   className="inventory-custom-input"
//                   value={reason}
//                   onChange={(e) => setReason(e.target.value)}
//                   placeholder="e.g., Employee salary"
//                   disabled={isSaving}
//                 />
//               </div>

//               {/* Amount */}
//               <div>
//                 <label>Amount *</label>
//                 <input
//                   type="number"
//                   className="inventory-custom-input"
//                   value={amount}
//                   onChange={(e) => setAmount(e.target.value)}
//                   placeholder="0.00"
//                   step="0.01"
//                   min="0"
//                   disabled={isSaving}
//                 />
//               </div>

//               {/* Add Button */}
//               <button
//                 type="button"
//                 className="inventory-btn inventory-btn-action inventory-btn-edit"
//                 onClick={addRow}
//                 disabled={expenses.length >= MAX_ITEMS || isSaving}
//                 style={{ marginBottom: '0' }}
//               >
//                 ➕ Add
//               </button>
//             </div>

//             {/* Expenses Table */}
//             <div style={{ marginTop: '20px', overflowX: 'auto' }}>
//               <table className="inventory-data-table">
//                 <thead>
//                   <tr>
//                     <th>Type</th>
//                     <th>Reason</th>
//                     <th style={{ textAlign: 'right' }}>Amount</th>
//                     <th style={{ width: '80px' }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {expenses.length === 0 ? (
//                     <tr>
//                       <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
//                         No expenses added yet
//                       </td>
//                     </tr>
//                   ) : (
//                     expenses.map((exp, index) => (
//                       <tr key={index}>
//                         <td>
//                           <span className={`expense-type-badge expense-type-${exp.type.toLowerCase()}`}>
//                             {exp.type}
//                           </span>
//                         </td>
//                         <td>{exp.reason}</td>
//                         <td style={{ textAlign: 'right', fontWeight: '600' }}>
//                           {exp.amount.toFixed(2)}
//                         </td>
//                         <td>
//                           <button
//                             type="button"
//                             className="inventory-btn inventory-btn-action inventory-btn-delete"
//                             onClick={() => removeRow(index)}
//                             disabled={isSaving}
//                             style={{ padding: '4px 8px', fontSize: '12px' }}
//                           >
//                             Remove
//                           </button>
//                         </td>
//                       </tr>
//                     ))
//                   )}

//                   {/* Totals Row */}
//                   {expenses.length > 0 && (
//                     <tr style={{ borderTop: '2px solid #ddd', fontWeight: 'bold' }}>
//                       <td colSpan="2" style={{ textAlign: 'right' }}>Total:</td>
//                       <td style={{ textAlign: 'right' }}>{totalAmount.toFixed(2)}</td>
//                       <td></td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Counter */}
//             {expenses.length > 0 && (
//               <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
//                 {expenses.length} / {MAX_ITEMS} expenses added
//               </p>
//             )}

//           </form>
//         </div>

//         {/* ── Footer ── */}
//         <footer className="inventory-modal-footer">
//           <button
//             className="inventory-btn inventory-btn-cancel"
//             onClick={handleClose}
//             disabled={isSaving}
//             type="button"
//           >
//             Cancel
//           </button>
//           <button
//             className="inventory-btn inventory-btn-save"
//             onClick={handleSubmit}
//             disabled={isSaving || expenses.length === 0}
//             type="button"
//           >
//             {isSaving ? 'Saving...' : `Save ${expenses.length} Expense(s)`}
//           </button>
//         </footer>

//       </div>
//     </div>
//   );
// };

// export default ExpenseModal;

import React, { useState, useEffect } from 'react';
import { alertNotification } from '../../utils/notification';
import expenseService from '../../services/expenseService';

/**
 * ExpenseModal Component
 * Modal for adding multiple expenses in batch
 *
 * @param {boolean}  isOpen
 * @param {Function} onClose
 * @param {Function} onSave
 * @param {Object}   expense  (optional - edit mode)
 * @param {boolean}  isSaving
 */
const ExpenseModal = ({ isOpen, onClose, onSave, expense, isSaving }) => {

  // ─── Constants ────────────────────────────────────────────────────────────
  const MAX_ITEMS     = 5;
  const EXPENSE_TYPES = [
    'FUEL', 'SALARY', 'UTILITIES', 'RENT', 'MAINTENANCE',
    'OFFICE_SUPPLIES', 'TRANSPORT', 'MARKETING', 'SOFTWARE',
    'BANK_CHARGES', 'TAX', 'TRAVEL', 'FOOD',
  ];

  // ─── Helpers ──────────────────────────────────────────────────────────────
const todayISO = () => {
  return new Date().toLocaleDateString('en-CA', {
    timeZone: 'Asia/Colombo',
  });
};

  // ─── State ────────────────────────────────────────────────────────────────
  const [expenseType,    setExpenseType]    = useState('SALARY');
  const [customType,     setCustomType]     = useState('');
  const [showCustomType, setShowCustomType] = useState(false);
  const [reason,         setReason]         = useState('');
  const [amount,         setAmount]         = useState('');
  const [date,           setDate]           = useState(todayISO());
  const [inventories,    setInventories]    = useState([]);
  const [inventoryId,    setInventoryId]    = useState('');
  const [expenses,       setExpenses]       = useState([]);

  // ─── Effects ──────────────────────────────────────────────────────────────
  useEffect(() => {
    if (expense) {
      setExpenses([
        {
          type:        expense.type   || 'SALARY',
          reason:      expense.reason || '',
          amount:      expense.amount || 0,
          date:        expense.date   || todayISO(),
        },
      ]);
    } else {
      setExpenses([]);
    }

    setExpenseType('SALARY');
    setCustomType('');
    setShowCustomType(false);
    setReason('');
    setAmount('');
    setDate(todayISO());
  }, [expense, isOpen]);

  useEffect(() => {
    const fetchInventories = async () => {
      try {
        const data = await expenseService.getActiveInventories();
        setInventories(data);
      } catch (error) {
        alertNotification('Failed to load inventories', 'error');
      }
    };

    if (isOpen) fetchInventories();
  }, [isOpen]);

  // ─── Handlers ─────────────────────────────────────────────────────────────
  const addRow = () => {
    if (!inventoryId) {
      alertNotification('Inventory is required', 'error');
      return;
    }

    if (!date) {
      alertNotification('Date is required', 'error');
      return;
    }

    if (!reason.trim()) {
      alertNotification('Reason is required', 'error');
      return;
    }

    if (!amount || parseFloat(amount) <= 0) {
      alertNotification('Valid amount is required', 'error');
      return;
    }

    const finalType = showCustomType ? customType.trim() : expenseType;

    if (showCustomType && !customType.trim()) {
      alertNotification('Custom type is required', 'error');
      return;
    }

    if (expenses.length >= MAX_ITEMS) {
      alertNotification(`Maximum ${MAX_ITEMS} expenses allowed`, 'error');
      return;
    }

    setExpenses(prev => [
      ...prev,
      {
        type:        finalType,
        reason:      reason.trim(),
        amount:      parseFloat(amount),
        date:        date,                   // "YYYY-MM-DD"
        inventoryId: parseInt(inventoryId),
      },
    ]);

    // Clear per-row inputs; keep inventory + date for convenience
    setReason('');
    setAmount('');
    if (showCustomType) setCustomType('');
  };

  const removeRow = (index) => {
    setExpenses(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (expenses.length === 0) {
      alertNotification('Please add at least one expense', 'error');
      return;
    }

    onSave({ expenses });
  };

  const handleClose = () => {
    if (!isSaving) {
      onClose();
      setExpenses([]);
      setExpenseType('SALARY');
      setCustomType('');
      setShowCustomType(false);
      setReason('');
      setAmount('');
      setDate(todayISO());
      setInventoryId('');
    }
  };

  // ─── Derived ──────────────────────────────────────────────────────────────
  const totalAmount = expenses.reduce((sum, exp) => sum + exp.amount, 0);

  // ─── Guard ────────────────────────────────────────────────────────────────
  if (!isOpen) return null;

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="inventory-modal-overlay">
      <div className="inventory-modal-content" style={{ maxWidth: '900px' }}>

        {/* ── Header ── */}
        <header className="inventory-modal-header">
          <h3 className="inventory-modal-title">
            {expense ? 'Edit Expense' : 'Add New Expenses'}
          </h3>
          <button
            className="inventory-close-modal-btn"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            ×
          </button>
        </header>

        {/* ── Body ── */}
        <div className="inventory-modal-body">
          <form onSubmit={handleSubmit}>

            {/* ── Row 1 : Inventory · Date · Type ── */}
            <div
              className="inventory-form-grid"
              style={{ gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}
            >
              {/* Inventory */}
              <div>
                <label>Inventory *</label>
                <select
                  className="inventory-custom-input"
                  value={inventoryId}
                  onChange={(e) => setInventoryId(e.target.value)}
                  disabled={isSaving}
                >
                  <option value="">Select Inventory</option>
                  {inventories.map(inv => (
                    <option key={inv.id} value={inv.id}>{inv.name}</option>
                  ))}
                </select>
              </div>

              {/* Date */}
              <div>
                <label>Date *</label>
                <input
                  type="date"
                  className="inventory-custom-input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  disabled={isSaving}
                  max={todayISO()}
                />
              </div>

              {/* Type */}
              <div>
                <label>Type *</label>
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                  {!showCustomType ? (
                    <>
                      <select
                        className="inventory-custom-input"
                        value={expenseType}
                        onChange={(e) => setExpenseType(e.target.value)}
                        disabled={isSaving}
                        style={{ flex: 1 }}
                      >
                        {EXPENSE_TYPES.map(type => (
                          <option key={type} value={type}>{type}</option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => setShowCustomType(true)}
                        disabled={isSaving}
                        title="Add custom type"
                        style={{
                          padding: '8px', background: '#007bff', color: 'white',
                          border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px',
                        }}
                      >
                        ✏️
                      </button>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className="inventory-custom-input"
                        value={customType}
                        onChange={(e) => setCustomType(e.target.value)}
                        placeholder="Enter custom type"
                        disabled={isSaving}
                        style={{ flex: 1 }}
                      />
                      <button
                        type="button"
                        onClick={() => { setShowCustomType(false); setCustomType(''); }}
                        disabled={isSaving}
                        title="Back to dropdown"
                        style={{
                          padding: '8px', background: '#6c757d', color: 'white',
                          border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px',
                        }}
                      >
                        ↩️
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* ── Row 2 : Reason · Amount · Add btn ── */}
            <div
              className="inventory-form-grid"
              style={{ gridTemplateColumns: '2fr 1fr auto', gap: '12px', alignItems: 'end', marginBottom: '20px' }}
            >
              {/* Reason */}
              <div>
                <label>Reason *</label>
                <input
                  type="text"
                  className="inventory-custom-input"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="e.g., Employee salary"
                  disabled={isSaving}
                />
              </div>

              {/* Amount */}
              <div>
                <label>Amount *</label>
                <input
                  type="number"
                  className="inventory-custom-input"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  disabled={isSaving}
                />
              </div>

              {/* Add Button */}
              <button
                type="button"
                className="inventory-btn inventory-btn-action inventory-btn-edit"
                onClick={addRow}
                disabled={expenses.length >= MAX_ITEMS || isSaving}
                style={{ marginBottom: '0' }}
              >
                ➕ Add
              </button>
            </div>

            {/* ── Expenses Table ── */}
            <div style={{ overflowX: 'auto' }}>
              <table className="inventory-data-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th style={{ textAlign: 'right' }}>Amount</th>
                    <th style={{ width: '80px' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                        No expenses added yet
                      </td>
                    </tr>
                  ) : (
                    expenses.map((exp, index) => (
                      <tr key={index}>
                        <td style={{ whiteSpace: 'nowrap', color: '#555', fontSize: '13px' }}>
                          {exp.date}
                        </td>
                        <td>
                          <span className={`expense-type-badge expense-type-${exp.type.toLowerCase()}`}>
                            {exp.type}
                          </span>
                        </td>
                        <td>{exp.reason}</td>
                        <td style={{ textAlign: 'right', fontWeight: '600' }}>
                          {exp.amount.toFixed(2)}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="inventory-btn inventory-btn-action inventory-btn-delete"
                            onClick={() => removeRow(index)}
                            disabled={isSaving}
                            style={{ padding: '4px 8px', fontSize: '12px' }}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))
                  )}

                  {/* Totals Row */}
                  {expenses.length > 0 && (
                    <tr className="totals-row">
                      <td colSpan="3" style={{ textAlign: 'right' }}>Total:</td>
                      <td style={{ textAlign: 'right' }}>{totalAmount.toFixed(2)}</td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Counter */}
            {expenses.length > 0 && (
              <span className="expense-counter-pill" style={{ marginTop: '10px', display: 'inline-flex' }}>
                📋 {expenses.length} / {MAX_ITEMS} expenses added
              </span>
            )}

          </form>
        </div>

        {/* ── Footer ── */}
        <footer className="inventory-modal-footer">
          <button
            className="inventory-btn inventory-btn-cancel"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            Cancel
          </button>
          <button
            className="inventory-btn inventory-btn-save"
            onClick={handleSubmit}
            disabled={isSaving || expenses.length === 0}
            type="button"
          >
            {isSaving ? 'Saving...' : `Save ${expenses.length} Expense(s)`}
          </button>
        </footer>

      </div>
    </div>
  );
};

export default ExpenseModal;
